module.exports = __webpack_public_path__ + "assets/3d-rocket-injector-56a4e56e2402ad1e8ea34cb45d84351f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/3d-rocket-injector.jpg
// module id = 502
// module chunks = 1